<template>
  <div class="mainDiv">
    <!-- <filter-div /> -->
    <navigation-bar type="crm" />
    <div></div>
    <div class="upperDiv">
      <div class="headerDiv">
        <h3 class="heading">All Users</h3>
        <div style="display: flex">
          <button class="button mr-4" @click="openDialog">
            <p class="buttonText">Apply Filter</p>
          </button>
          <button
            class="button"
            v-if="showFilterReset"
            @click="handleResetFilters"
          >
            <p class="button_red_text">Reset Filters</p>
          </button>
        </div>
      </div>
      <pagination-div :getUserDetails="getUserList" />
    </div>
    <div class="headerflatline">
      <p class="headerlines">Profile Image</p>
      <p class="headerlinesUserName">User Name</p>
      <p class="headerlinesAcquistion">Acquisition Date</p>
      <p class="headerlinesDistrict">District</p>
      <p class="headerlinesState">State</p>
      <p class="headerlinesState">Contact Number</p>
    </div>

    <div v-if="!loader">
      <div class="UserList" v-if="data">
        <div style="max-height: 500px">
          <div v-for="item in data.users_details" :key="item.id">
            <user-list-card :userData="item" />
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="loader">
        <v-progress-circular
          :width="6"
          :size="80"
          color="green"
          indeterminate
        ></v-progress-circular>
      </div>
    </div>

    <!-- <div class="footerPagination">
      <pagination-div />
    </div>
    <div> -->
    <!-- <filter-div /> -->
    <!-- 
     
    </div> -->
    <div v-if="data && data.users_details.length == 0">
      <p
        style="
          display: flex;
          height: 400px;
          width: 100%;
          justify-content: center;
          align-items: center;
        "
      >
        No User Found
      </p>
    </div>
    <div style="padding:'auto;margin:auto;width:60%" v-if="dialog">
      <filter-modal
        ref="dialogue"
        :dialog="dailog"
        :getUserDetails="getUserList"
        :isfilterApplied="handleFilterApply"
      />
    </div>
  </div>
</template>

<script>
import userListCard from "./components/userCard.vue";
import pagination from "../../../views/MainDashboard/Common/pagination.vue";
import filterModal from "./components/filterModal.vue";
import filterDiv from "./components/filterDiv.vue";
import PaginationDiv from "./components/paginationCounterDiv.vue";
import API_URL from "../../../helpers/apiUrls";
import navigationBar from "../../../layouts/MainDashboard/components/navigation-bar.vue";
import router from "../../../router";
import accessToken from "../../../helpers/accessToken";
import apiEndpoints from "@/helpers/apiUrls";
export default {
  name: "userlistPage",
  components: {
    "user-list-card": userListCard,
    "filter-div": filterDiv,
    pagination: pagination,
    "pagination-div": PaginationDiv,
    "filter-modal": filterModal,
    "navigation-bar": navigationBar,
  },
  data() {
    return {
      data: null,
      addProductDialog: false,
      customProductDialog: false,
      productDetailsDialog: false,
      productDetails: {},
      totalData: 0,
      heading: "",
      filter: "",
      order: "",
      productPerPage: 50,
      dialog: true,
      pageNo: 1,
      loader: true,
      showFilterReset: false,
    };
  },
  created() {
    
  },
  mounted() {
    this.getSideBarItems();
    this.showFilterReset =
      this.$store.getters["crmFilters/GET_IS_FILTER_APPLIED"];
  },
  "$store.state": {
    handler(newVal, oldVal) {
      // Handle state change
      console.log("showFilterReset changed:", newVal, oldVal);
      this.showFilterReset =
        this.$store.getters["crmFilters/GET_IS_FILTER_APPLIED"];
    },
    deep: true, // Watch for nested changes if applicable
  },
  methods: {
    getSideBarItems() {
      const successHandler = (response) => {
        if (response.status === 200) {
          console.log("ADD COMMENT RES ", response.data);

          const isSuperAdmin = response.data.is_super_admin;
        
          if (!isSuperAdmin) {
            this.$router.push({ name: "createContent" });
            //this.showToast("Access Denied!", "error", 10000);
          }
          this.$store.dispatch(
            "mainStore/setSuperAdmin",
            response.data.is_super_admin
          );
        }
      };

      const errorHandler = (error) => {
        console.log(error.data);
      };

      const headers = {
        Authorization: `Bearer ${accessToken.getAccessToken()}`,
      };

      this.requestGET(
        apiEndpoints.sidebar,
        {},
        headers,
        successHandler,
        errorHandler
      );
    },

    handleFilterApply() {
      this.showFilterReset =
        this.$store.getters["crmFilters/GET_IS_FILTER_APPLIED"];
    },
    openDialog() {
      this.$refs.dialogue.open(); // Calls the 'open' method of the dialogue component
      // this.dialog=true
    },
    getUserList() {
      this.loader = true;
      this.pageNo = this.$store.getters["crmFilters/GET_PAGE"];
      const successHandler = (response) => {
        if (response.status === 200) {
          console.log("Crop Stage", response.data);
          this.data = response.data;
          this.loader = false;
          //this.$store.dispatch("crmFilters/setPage", pageNo);
        }
      };

      const errorHandler = (error) => {
        this.showToast("Something went wrong internally!", "error", 10000);
        console.log(error);
      };
      const data = {
        data_per_page: 25,
        page: this.pageNo,
        filter: this.$store.getters["crmFilters/GET_FILTER_PAYLOAD"],
      };
      this.requestPOST(
        `${API_URL.user_list}`,
        data,
        {},
        successHandler,
        errorHandler,
        process.env.VUE_APP_API_BASE_URL_DISCOVERY,
        300000
      );
    },
    handleResetFilters() {
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.mainDiv {
  background: #f9faf8;
}
.heading {
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0.01em;
  color: #3a3f3a;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin-bottom: 24px;
}
.headerDiv {
  display: flex;
  justify-content: space-between;
  padding-left: 2px;
}
.button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 12px 8px 16px;
  gap: 8px;

  // position: absolute;
  width: 139px;
  height: 40px;
  left: 1253px;
  top: 104px;

  background: #ffffff;
  border-radius: 5px;
}
.button_red_text {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 0px;
  /* identical to box height */

  text-align: right;
  letter-spacing: 0.01em;

  /* Main/Green */

  color: red;
}
.buttonText {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 0px;
  /* identical to box height */

  text-align: right;
  letter-spacing: 0.01em;

  /* Main/Green */

  color: #189d3b;
}
.UserList {
  margin-top: 12px;
  background: #f9faf8;

  overflow-x: scroll;
}
.upperDiv {
  padding: 48px;
  padding-bottom: 12px;
}
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
}
.headerflatline {
  display: flex;
  width: 100%;
  height: 40px;
  background: white;
  align-items: center;
}
.headerlines {
  font-family: "Roboto";
  font-style: normal;
  margin-bottom: 0px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  width: 10%;
  display: flex;
  justify-content: center;
  /* Greyscale/Gray 3 */

  color: #777777;
}
.headerlinesUserName {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 0px;
  line-height: 16px;
  width: 14%;
  /* Greyscale/Gray 3 */

  color: #777777;
}
.headerlinesAcquistion {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 0px;
  width: 14.8%;
  /* Greyscale/Gray 3 */

  color: #777777;
}
.headerlinesState {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  width: 14.8%;
  /* Greyscale/Gray 3 */
  margin-bottom: 0px;

  color: #777777;
}
.headerlinesDistrict {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  width: 11%;
  margin-bottom: 0px;
  /* Greyscale/Gray 3 */

  color: #777777;
}
.footerPagination {
  padding-left: 48px;
  padding-right: 48px;
  // display:flex;
  // justify-content: space-between;
}
.button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 12px 8px 16px;
  gap: 8px;

  // position: absolute;
  width: 139px;
  height: 40px;
  left: 1253px;
  top: 104px;

  background: #ffffff;
  border-radius: 5px;
}
.buttonText {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 0px;
  /* identical to box height */

  text-align: right;
  letter-spacing: 0.01em;

  /* Main/Green */

  color: #189d3b;
}
</style>
